import React, { useState, useEffect } from "react";
import ReactAudioPlayer from "react-audio-player";

const AudioComponent = ({ src }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [audio] = useState(new Audio(src));

  useEffect(() => {
    const handleCanPlayThrough = () => {
      setIsLoading(false);
    };

    audio.addEventListener("canplaythrough", handleCanPlayThrough);

    return () => {
      audio.removeEventListener("canplaythrough", handleCanPlayThrough);
    };
  }, [audio]);

  return (
    <div>
      {isLoading ? (
        <p>Caricamento audio in corso... Per favore, attendi.</p>
      ) : (
        <ReactAudioPlayer src={src} autoPlay={false} controls />
      )}
    </div>
  );
};

export default AudioComponent;
